// extracted by mini-css-extract-plugin
module.exports = {"familyCardContainer":"FamilyDirectAccess_familyCardContainer__USb70","familyTextLabel":"FamilyDirectAccess_familyTextLabel__HHD1q"};